import { useState } from 'react';
import cn from 'classnames';
import { compact } from 'lodash-es';
import { RichTextViewer as QuillRichTextViewer, TextButton, Typography, Collapse } from 'seagull';
import { ResponsiveModal } from "../../components/ResponsiveModal";
import { useOverlayContext, useIoContext, useStoreActions } from "../../../contexts";
import { approvalMethodNoticePeriodModel, legalTermsModel, relationshipModel } from "../../../models";
import { requestAccountantAccessModel } from "../../../models/request-accountant-access";
import { RichTextViewer } from "../../../RichTextViewer";
import { useResponsive } from "../../contexts";
import styles from "./AgreementTerms.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const TitleTypography = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    weight: "bold",
    as: "span",
    className: styles.titleTypography,
    children: children
  });
};
export function AgreementTerms(props) {
  const {
    relationship
  } = props;
  const overlayContext = useOverlayContext();
  const {
    api
  } = useStoreActions();
  const {
    isMobile,
    isDesktop
  } = useResponsive();
  const [tocVisible, setTocVisible] = useState(false);
  const {
    openNewTab
  } = useIoContext();
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    children: /*#__PURE__*/_jsxs("section", {
      className: styles.section,
      children: [/*#__PURE__*/_jsx("div", {
        className: cn(styles.sectionTitle, {
          [styles.mobile]: isMobile
        }),
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          weight: "normal",
          children: "Agreement Terms"
        })
      }), /*#__PURE__*/_jsx("ul", {
        children: compact([/*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Effective date of agreement: "
          }), relationshipModel.formatEffectiveDate(relationship)]
        }), /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Payment terms: "
          }), relationshipModel.paymentTermsText(relationship)]
        }), /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Amendments: "
          }), approvalMethodNoticePeriodModel.amendmentsDescription(relationship.amendmentsApprovalMethod)]
        }), approvalMethodNoticePeriodModel.isAutoApproval(relationship.invoicesApprovalMethod) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Out of scope charges: "
          }), approvalMethodNoticePeriodModel.invoicesDescription(relationship.invoicesApprovalMethod)]
        }), requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && /*#__PURE__*/_jsxs(Typography, {
          "data-testid": "accountant-access-information",
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Accountant Access: "
          }), "will allow the ".concat(relationship.vendor.name, " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods. ")]
        }), /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Typography, {
            "data-testid": "additional-terms-of-service",
            children: [/*#__PURE__*/_jsx(TitleTypography, {
              children: "Additional terms of service: "
            }), /*#__PURE__*/_jsx(TextButton, {
              "data-testid": "additional-terms-of-service-btn",
              onClick: legalTermsModel.isPDF(relationship.legalTerms) ? async () => {
                const pdfViewUrl = await api.business.getLegalTermsDownloadURL(relationship.legalTerms.pdfUniqueName, relationship.vendor.id);
                if (pdfViewUrl) {
                  openNewTab(pdfViewUrl);
                }
              } : isMobile ? () => {
                overlayContext.showModal({
                  content: _ref2 => {
                    let {
                      dismissModal
                    } = _ref2;
                    return /*#__PURE__*/_jsx(ResponsiveModal, {
                      backTitle: "Back to agreement",
                      title: "Terms and conditions",
                      isDesktop: isDesktop,
                      onClose: dismissModal,
                      children: /*#__PURE__*/_jsx(RichTextViewer, {
                        value: relationship.legalTerms.richTextContent
                      })
                    });
                  }
                });
              } : () => {
                setTocVisible(!tocVisible);
              },
              children: "Read more"
            })]
          }), isDesktop && /*#__PURE__*/_jsx(Collapse, {
            in: tocVisible,
            children: legalTermsModel.isRichText(relationship.legalTerms) ? /*#__PURE__*/_jsx(RichTextViewer, {
              value: relationship.legalTerms.richTextContent
            }) : /*#__PURE__*/_jsx(Typography, {
              skin: "secondary",
              children: relationship.coverLetter
            })
          })]
        }), relationship.extraClause && /*#__PURE__*/_jsxs(Typography, {
          "data-testid": "additional-notes",
          className: styles.noteContainer,
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Agreement notes: "
          }), /*#__PURE__*/_jsx(QuillRichTextViewer, {
            className: styles.note,
            "data-testid": "extra-clause-rich-text-viewer",
            value: relationship.extraClause
          })]
        })]).map((text, idx) => /*#__PURE__*/_jsx("li", {
          className: styles.listItem,
          children: /*#__PURE__*/_jsx(Typography, {
            children: text
          })
        }, idx))
      })]
    })
  });
}